import React from 'react'
import CreatableSelect from 'react-select/creatable'
import { OptionsOrGroups, GroupBase, SingleValue } from 'react-select/dist/declarations/src/types'

interface ReviewItemSelectProps {
  value: { value: string; label: string } | null
  options: { value: string; label: string }[]
  onChange: (value: SingleValue<{ value: string; label: string }>) => void
  isClearable?: boolean
}

interface Option {
  value: string
  label: string
}

const indicatorSeparator = () => ({ display: 'none' })
const indicatorsContainer = (styles: Record<string, unknown>) => ({
  ...styles,
  '& > div:first-of-type': { paddingRight: 0 },
  '& > div:last-of-type': { paddingLeft: 0 },
})
const formatCreateLabel = (inputValue: string) => `"${inputValue}"`
const isValidNewOption = (
  inputValue: string,
  _,
  selectOptions: OptionsOrGroups<Option, GroupBase<Option>>,
) => {
  const exists = selectOptions.some(option => option.label === inputValue)
  return !!inputValue && !exists
}

export const ReviewItemSelect: React.FC<ReviewItemSelectProps> = ({
  value,
  options,
  onChange,
  isClearable = true,
}) => {
  return (
    <CreatableSelect
      value={value}
      className="rounded-md"
      options={options}
      styles={{ indicatorSeparator, indicatorsContainer }}
      onChange={onChange}
      isClearable={isClearable}
      formatCreateLabel={formatCreateLabel}
      isValidNewOption={isValidNewOption}
    />
  )
}
